import React from 'react';

const MembershipStart = ({ nextStep }) => {
    return (
        <div className="membership-start-container">
            <div className="membership-start-overlay">
                <div className="membership-start-content">
                    <img
                        className="membership-start-logo"
                        src="https://www.churchofmatrix.org/assets/images/matrix-avatar.png"
                        alt="Church of Matrix"
                    />
                    <button onClick={nextStep} className="membership-start-button">
                        Get Started
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MembershipStart;
